import React, { forwardRef } from "react";
import { FiPhone, FiMail } from 'react-icons/fi';
import { FaGlobe } from 'react-icons/fa';
import { GoLocation } from 'react-icons/go';

const ReceiptTemplate = forwardRef((props, ref) => {
  const { data } = props;
  if (!data) return null;

  const {
    _id,
    invoiceNumber,
    schoolId,
    description,
    // penalty = 0,
    // isCancel,
    paymentDate,
    paidItems = [],
    paidBy,
    studentId,
    paymentStatus,
    entityId,
    // onlineTransactionId,
    chequeDate,
    chequeNumber,
    paymentType
  } = data;



  // Initialize totals
  let totalAmount = 0;

  paidItems.forEach((item) => {
    totalAmount += item.amountPaid || 0;
  });


  const {
    address = "",
    // branchName = "",
    // city = "",
    nameOfSchool = "N/A",
    currency = "",
    logo = "",
    contactDetails
  } = schoolId || {};

  return (
    <div className="p-6 bg-gray-50 rounded-md shadow-lg max-w-3xl mx-auto"
      ref={ref}
      style={{ direction: "ltr", textAlign: "left" }}
    >
      <div className="flex w-full flex-row  gap-10 mb-2 ">

        <div className="flex flex-col gap-2 w-[70%] ">

          <div className="w-[99%] h-[3rem]  bg-[#7F31AB]  relative">
            <div class="w-10 h-40 bg-gray-50 rotate-45  absolute end-2 top-[-70%]"></div>
          </div>
          <div className="w-[90%] h-[1.5rem]  bg-[#8C1E60]">
          </div>
        </div>
        <div>
          <div className="w-full flex flex-row gap-4 justify-center items-center h-[5rem]">
            {logo && <img src={logo} alt="Logo" className="w-10 h-10 rounded-full" />}
            <h1 className="font-bold text-lg">{nameOfSchool}</h1>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center justify-center font-bold text-3xl mt-8 mb-2">
        RECEIPT
      </div>
      <div className="text-sm text-gray-800 mb-4 flex justify-between">
        {studentId && <div>
          <p><strong>Receipt Number:</strong> {_id?.toUpperCase()}</p>
          <p><strong>Name:</strong> {studentId?.firstName} {studentId?.lastName}</p>
          <p><strong>Email:</strong> {studentId?.email}</p>
          <p><strong>Contact:</strong> {studentId?.contactNumber}</p>
        </div>}
        {entityId && <div>
          <p><strong>Receipt Number:</strong> {_id?.toUpperCase()}</p>
          <p><strong>Name:</strong> {entityId?.entityName} </p>
          <p><strong>Email:</strong> {entityId?.email}</p>
          <p><strong>Contact:</strong> {entityId?.contactNumber}</p>
        </div>}
        <div>
          <p><strong>Invoice No:</strong> {invoiceNumber || ""}</p>
          <p><strong>Issue Date:</strong> {paymentDate?.slice(0, 10)}</p>
          <p><strong>Status:</strong> {paymentStatus}</p>
          <p><strong>Currency:</strong> {currency}</p>

        </div>
      </div>
      <div className="my-4 border-t border-gray-500">
        <table className="w-full text-start border border-gray-400">
          <tbody>
            <tr className="border-b border-gray-400">
              <td className="font-semibold py-2 px-4 border-e border-gray-400">Total Paid:</td>
              <td className="py-2 px-4">{totalAmount?.toFixed(2)} {currency}</td>
            </tr>
            <tr className="border-b border-gray-400">
              <td className="font-semibold py-2 px-4 border-e border-gray-400">Payment Date:</td>
              <td className="py-2 px-4">{paymentDate?.slice(0, 10)}</td>
            </tr>
            <tr className="border-b border-gray-400">
              <td className="font-semibold py-2 px-4 border-e border-gray-400">Payment Type:</td>
              <td className="py-2 px-4">{paymentType}</td>
            </tr>
            <tr className="border-b border-gray-400">
              <td className="font-semibold py-2 px-4 border-e border-gray-400">Paid By:</td>
              <td className="py-2 px-4">{paidBy || "Self"}</td>
            </tr>
            {chequeNumber && (
              <tr className="border-b border-gray-400">
                <td className="font-semibold py-2 px-4 border-e border-gray-400">Cheque Number:</td>
                <td className="py-2 px-4">{chequeNumber}</td>
              </tr>
            )}
            {chequeDate && (
              <tr className="border-b border-gray-400">
                <td className="font-semibold py-2 px-4 border-e border-gray-400">Cheque Date:</td>
                <td className="py-2 px-4">{chequeDate}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>



      <div className="text-sm text-gray-700">
        <ul className="list-disc px-5">
          {description && <li>{description}</li>}
        </ul>
        <h2 className="text-base font-semibold mt-6 mb-2">Notes</h2>
        <ul className="list-disc ps-5 space-y-1 text-sm text-gray-700">
          <li>Thank you for your payment.</li>
          <li>Please retain this receipt for your records.</li>
          <li>For questions or clarifications, contact us at {contactDetails?.email} | {contactDetails?.contactNumber}.</li>

        </ul>
        
      </div>
      <div>
        <div className="bg-[#89125B] text-white p-6 relative  overflow-hidden">
          <div class="w-40 h-40 bg-purple-500 rotate-45  absolute end-[-15%] top-[-60%]"></div>
          <div className="w-full flex flex-row items-center justify-around">

            <div className="flex flex-col items-start gap-4">
              {/* Phone */}
              <div className="flex items-center gap-2">
                <FiPhone className="text-lg" />
                <span>{contactDetails?.contactNumber}</span>
              </div>

              {/* Email */}
              <div className="flex items-center gap-2">
                <FiMail className="text-lg" />
                <span>{contactDetails?.email}</span>
              </div>
            </div>

            <div className="flex flex-col items-start gap-4">
              {/* Website */}
              <div className="flex items-center gap-2">
                <FaGlobe className="text-lg" />
                <span>{contactDetails?.website}</span>
              </div>

              {/* Location */}
              <div className="flex items-center gap-2">
                <GoLocation className="text-lg" />
                <span>{address}</span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
});

export default ReceiptTemplate;
